// Shared helpers for rendering orders on both the customer and admin sides.

export const ORDER_STATUS_FLOW = [
  "draft",
  "quoted",
  "accepted",
  "paid",
  "in_production",
  "shipped",
  "complete",
] as const;

export type OrderStatus = (typeof ORDER_STATUS_FLOW)[number] | "cancelled";

export const STATUS_META: Record<string, { label: string; className: string }> = {
  draft: { label: "Draft", className: "bg-slate-500/15 text-slate-300" },
  quoted: { label: "Quote sent", className: "bg-amber-500/15 text-amber-300" },
  accepted: { label: "Quote accepted", className: "bg-sky-500/15 text-sky-300" },
  paid: { label: "Paid", className: "bg-emerald-500/15 text-emerald-300" },
  in_production: { label: "In production", className: "bg-indigo-500/15 text-indigo-300" },
  shipped: { label: "Shipped", className: "bg-cyan-500/15 text-cyan-300" },
  complete: { label: "Complete", className: "bg-emerald-500/15 text-emerald-300" },
  cancelled: { label: "Cancelled", className: "bg-rose-500/15 text-rose-300" },
};

export function money(v: number | null | undefined): string {
  const n = Number(v ?? 0);
  return "R" + n.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtDate(d?: string | null): string {
  return d ? String(d).replace("T", " ").slice(0, 16) : "";
}
